<template>
  <el-container>
    <el-main style="padding: 5px !important">
      <el-row
        v-for="(page, index) of pages"
        :key="index"
        :gutter="10"
        type="flex"
        class="p-tb-10 p-lr-30 t-c"
      >
        <el-col :span="6" v-for="(item, index) of page" :key="index">
          <el-card shadow="hover">
            <div>
              <h3>{{ item.name }}</h3>
            </div>
            <div style="min-height: 105px">
              <el-input
                v-if="item.search"
                v-model="item.input"
                placeholder="请输入轻任务订单号"
                clearable
                oninput="this.value=this.value.replace(/[^\d]/g,'')"
              ></el-input>
              <h4>说明:{{ item.remark ? item.remark : '--' }}</h4>
              <h4>
                推荐使用人:{{ item.recommendUser ? item.recommendUser : '--' }}
              </h4>
            </div>
            <div v-if="!item.search" style="padding: 0 0 15px 0">
              <span style="color: #00bfff">数据已生成</span>
            </div>
            <el-button
              type="primary"
              plain
              @click="download(item)"
              :disabled="judeDis(item)"
            >
              点击下载
            </el-button>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import { getObj, saveLog, checkExport } from '@/api/dataReport/unifiedReport';
import { statistics } from '@/api/dot/flow';
import { mapGetters, mapState } from 'vuex';
import axios from '@/router/axios';

export default {
  data() {
    const item = {
      date: '2016-05-02',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1518 弄',
    };
    return {
      dataList: [],
      tableData: Array(20).fill(item),
      staParams: null,
    };
  },
  computed: {
    pages() {
      const pages = [];
      this.dataList.forEach((item, index) => {
        const page = Math.floor(index / 4); //4代表4条为一行，随意更改
        if (!pages[page]) {
          pages[page] = [];
        }
        pages[page].push(item);
      });
      return pages;
    },
    ...mapGetters(['permissions']),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.curPath = to.path;
      vm.oldPath = from.path;
    });
  },
  mounted() {
    getObj().then((res) => {
      let data = res.data.data;
      if (data) {
        // data.push({
        //   id: '43',
        //   createTime: '1643077944508',
        //   name: 'DOT质控抽查数据',
        //   url: '',
        //   type: 'dot_sentence_mt_data',
        //   input: '',
        //   sort: 19,
        //   search: true,
        //   remark: '请输入需要导出质控工作数据的轻任务订单号',
        //   recommendUser: '刘劲涛',
        //   updateTime: '1643077944508',
        // });
        this.dataList = data;
      }
    });
    this.staParams = {
      u_id: this.userInfo.staffId,
      time: new Date().getTime(),
      browser: navigator.userAgent.toLowerCase(),
      url: document.URL,
      scene_name: '统一报表',
    };
    this.statistics();
  },
  methods: {
    statistics() {
      statistics(
        Object.assign(
          {
            event_type: 'view',
            ref_url: this.oldPath,
          },
          this.staParams,
        ),
      );
    },

    judeDis(item) {
      if (item.search) {
        return item.input === '' || item.input === null || item.input == 0;
      } else {
        return false;
      }
    },
    click(item) {
      console.log('click');
      this.$set(item, 'show', !item.show);
    },
    beforeEnter(el) {
      console.log('beforeEnter');
      el.style.opacity = '0';
      el.style.transform = 'translateY(100px)';
    },
    enter(el) {
      console.log('enter');
      el.offsetWidth;
      el.style.transition = 'all 0.5s ease';
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    },
    afterEnter(el) {
      console.log('afterEnter');
    },
    enterCancelled(el) {
      console.log('enterCancelled');
    },
    beforeLeave(el) {
      console.log('beforeLeave');
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    },
    leave(el) {
      console.log('leave');
      el.offsetWidth;
      el.style.transition = 'all 0.5s ease';
      el.style.opacity = '0';
      el.style.transform = 'translateY(100px)';
    },
    afterLeave(el) {
      console.log('afterLeave');
    },
    leaveCancelled(el) {
      console.log('leaveCancelled');
    },
    mouseOver(item) {
      // this.$message.success(item.name+"鼠标进入")
      this.$set(item, 'show', true);
    },
    mouseOut(item) {
      this.$set(item, 'show', false);
      // this.$message.error(item.name+"鼠标离开")
    },
    download(item) {
      if (!item.search) {
        window.location.href = item.url;
        saveLog(item).then((res) => {
          console.log(res);
        });
      } else {
        checkExport({ orderId: item.input }).then((res) => {
          if (res.data.data > 0) {
            axios({
              method: 'post',
              url: '/dotadmin/dotadmin/dataDownload/export',
              data: { orderId: item.input },
              responseType: 'blob', // 重要， 限制返回的数据结构为blob格式，方便前端做转换
            }).then((res) => {
              if (res.data.type === 'application/msexcel') {
                let a = res.headers['content-disposition'];
                let fileName = decodeURIComponent(a.substr(a.indexOf('=') + 1));
                const link = document.createElement('a');
                const blob = new Blob([res.data], {
                  type: 'application/vnd.ms-excel',
                });
                link.style.display = 'none';
                link.href = URL.createObjectURL(blob);
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              } else {
                this.$message.error('该订单号下无数据');
              }
            });
          } else if (res.data.data === -2) {
            this.$message.error('该订单号不存在');
          } else if (res.data.data === -3) {
            this.$message.error('该订单号下没有原始excel数据');
          } else if (res.data.data === -4) {
            this.$message.error('该订单号不存在原始excel数据中');
          } else {
            this.$message.error('系统位置错误，请联系管理员');
          }
        });
      }
      statistics(
        Object.assign(
          {
            event_name: '点击下载',
            event_type: 'click',
            class_name: 'export',
            class_url: '/dotadmin/dotadmin/dataDownload/export',
            event_params: '{orderId: item.input}',
          },
          this.staParams,
        ),
      );
    },
  },
};
</script>

<style>
.self-div {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s linear;
}
.g-btn:hover ~ .self-div {
  max-height: 300px;
}
</style>
